import React, { useEffect, useRef, useState } from "react"
import { collection, query, orderBy, onSnapshot } from "firebase/firestore"
import { db } from "../firebase/config"
import QuestionItem from "./QuestionItem"
import { CircularProgress, Typography } from "@mui/material"
import toast from "react-hot-toast"
import { getDeviceId } from "../utils/deviceUtils"

const QuestionList = ({ admin }) => {
  const [questions, setQuestions] = useState([])
  const [loading, setLoading] = useState(true)
  const containerRef = useRef(null)

  const isFirstLoad = useRef(true)
  const previousLength = useRef(0)


  useEffect(() => {
    const fetchDeviceId = async () => {
      const deviceId = await getDeviceId()

      const q = query(collection(db, "questions"), orderBy("createdAt", "asc"))

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const items = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
          }))

          setQuestions(items)
          setLoading(false)

          if (isFirstLoad.current) {
            if (items.length === 0) {
              toast("No questions yet.", { icon: "ℹ️" })
            } else {
              // Optionally toast a success message for first load
              // toast.success("Questions loaded!")
            }

            previousLength.current = items.length
            isFirstLoad.current = false
            return
          }

          if (items.length > previousLength.current) {
            if (items[items.length - 1]?.deviceId === deviceId) {
              toast.success("New question added!", {
                icon: "ℹ️"
              })
            } else {
              toast.success("Incoming new question!", {
                icon: "👀"
              })
            }
          }

          previousLength.current = items.length
        },
        (error) => {
          toast.error("Failed to load questions.")
          console.error(error)
          setLoading(false)
        }
      )

      return () => unsubscribe()
    }

    fetchDeviceId()
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight
    }
  }, [questions])

  if (loading) return <CircularProgress />

  return (
    <div
      ref={containerRef}
      style={{ overflowY: "auto", flex: 1, padding: "0 8px" }}
    >
      {questions.length === 0 ? (
        <Typography>No questions yet.</Typography>
      ) : (
        questions.map((q) => (
          <QuestionItem key={q.id} id={q.id} question={q} admin={admin} />
        ))
      )}
    </div>
  )
}

export default QuestionList
